import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService, AuthenticationService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ImapConfiguration } from '@app/_components/imap-configuration/imap-configuration';
import { ImapConfigurationService } from '@app/_components/imap-configuration/imap-configuration.service';
import { ImapConfigurationComponent } from '@app/_components/imap-configuration/imap-configuration/imap-configuration.component';
import { User } from '@app/_models';
import { Subscription } from 'rxjs';
import {ImapUserMappingComponent} from '@app/_components/imap-user-mapping/imap-user-mapping/imap-user-mapping.component';
@Component({
    selector: 'app-imap-configuration-list',
    templateUrl: './imap-configuration-list.component.html',
    styleUrls: ['./imap-configuration-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ImapConfigurationListComponent implements OnInit {
	private accesstypes: any;
	currentUser: User;
	currentUserSubscription: Subscription;
	constructor(
		private imapConfigurationService: ImapConfigurationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private authenticationService: AuthenticationService,
		private dialog: MatDialog,
	) {
		this.accesstypes = imapConfigurationService.accesstypes;
		this.currentUserSubscription = this.authenticationService.currentUser.subscribe(user => {
			this.currentUser = user;
		});
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	imapConfigurations: any;
	imapConfiguration: ImapConfiguration;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'imapConfigurationId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'email', header: 'Email', width: 'auto' },
		{ field: 'protocol', header: 'Protocol', width: 'auto' },
		{ field: 'host', header: 'Host', width: 'auto' },
		{ field: 'port', header: 'Port', width: 'auto' },
		{ field: 'lastreaduid', header: 'Last Read UId', width: 'auto' },
		{ field: 'msgreadpercall', header: 'Msg Read Per Call', width: 'auto' },
		{ field: 'linkedUserVO.firstName', header: 'User', width: 'auto' },
		{ field: 'access', header: 'Access', width: 'auto' },
		{ field: 'active', header: 'Active', width: 'auto' },
		{ field: 'gmailSyncEnabled', header: 'Gmail API', width: 'auto' },
		{ field: 'gmailBulkSyncStatus', header: 'Bulk Sync', width: 'auto' }
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.imapConfigurationId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;
			// event.filters['userId'] = {};
			// event.filters['userId'].value = this.currentUser.userId;
			// event.filters['userId'].matchMode = "in";

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-imapConfiguration-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.imapConfigurationService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.imapConfigurations = res.data.imapConfigurations;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.imapConfigurations = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return;
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(imapConfiguration: ImapConfiguration) {
		try {
			this.formLoading = true;
			this.imapConfigurationService.update(imapConfiguration)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.imapConfigurations.map((imapConfiguration, i) => {
							if (imapConfiguration.imapConfigurationId === res.data.imapConfiguration.imapConfigurationId) {
								this.imapConfigurations[i] = res.data.imapConfiguration;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(imapConfiguration: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(imapConfiguration));

			this.formLoading = true;
			this.imapConfigurationService.delete(imapConfiguration.imapConfigurationId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.imapConfigurations.splice(this.imapConfigurations.indexOf(imapConfiguration), 1);
						this.recordTotal = this.imapConfigurations.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ImapConfiguration ' + imapConfiguration.imapConfigurationId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ImapConfiguration ' + imapConfiguration.imapConfigurationId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ImapConfiguration'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ImapConfigurationComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addImapConfigurationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}
  managePermissions() {

    const dialogConfig = new MatDialogConfig();

    // settings
    dialogConfig.disableClose = false;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '400px';

    // pass data, ie rateBuicket: this.shortTermRentalId,
    dialogConfig.data = {
      title: 'Manage Mailbox permissions'
    };

    // open the popup and get a reference to it called dialogRef
    const dialogRef = this.dialog.open(ImapUserMappingComponent, dialogConfig);

    // to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
    dialogRef.componentInstance.doAdd.subscribe(
      data => {
        console.log('Dialog output:', data);

        // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
        dialogRef.close();
      });
  }

	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(imapConfiguration: ImapConfiguration) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			imapConfiguration: imapConfiguration,
			title: 'Edit ImapConfiguration'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ImapConfigurationComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateImapConfigurationCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteImapConfigurationCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addImapConfigurationCB(imapConfiguration: ImapConfiguration) {
		console.log('Adding ImapConfiguration: ' + JSON.stringify(imapConfiguration));
		// if we don't have a imapConfigurations array yet...
		if (!this.imapConfigurations) {
			this.imapConfigurations = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.imapConfigurations.unshift(imapConfiguration);

		// no idea what this is but it is required to update the array
		this.imapConfigurations = [...this.imapConfigurations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ImapConfiguration ' + imapConfiguration.imapConfigurationId + ' Added', life: 3000 });
	}

	updateImapConfigurationCB(imapConfiguration: ImapConfiguration) {
		console.log('Updating ImapConfiguration: ' + JSON.stringify(imapConfiguration));
		let itemIndex = this.imapConfigurations.findIndex((item: any) => item.imapConfigurationId === imapConfiguration.imapConfigurationId);
		this.imapConfigurations[itemIndex] = imapConfiguration;

		// no idea what this is but it is required to update the array
		this.imapConfigurations = [...this.imapConfigurations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ImapConfiguration ' + imapConfiguration.imapConfigurationId + ' Updated', life: 3000 });
	}

	deleteImapConfigurationCB(imapConfiguration: ImapConfiguration) {
		console.log('Removing ImapConfiguration: ' + imapConfiguration);
		this.imapConfigurations.splice(this.imapConfigurations.indexOf(imapConfiguration), 1);
		this.recordTotal = this.imapConfigurations.length;

		// no idea what this is but it is required to update the array
		this.imapConfigurations = [...this.imapConfigurations];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ImapConfiguration ' + imapConfiguration.imapConfigurationId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.imapConfigurations ? this.first === (this.imapConfigurations.length - this.rows) : true; }
	isFirstPage(): boolean { return this.imapConfigurations ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getAccessName(imapConfiguration: any) {
		if (imapConfiguration?.access) {
			const status = this.accesstypes.find((e: any) => e.value == imapConfiguration.access);
			return status.name;
		}
		else {
			return '';
		}
	}
  getUserFullName(user: any) {
    let name = '';
    if (user?.firstName) {
      name += user?.firstName ;
    }
    if (user?.lastName) {
      name += ' ' + user?.lastName ;
    }
    return name;
  }

	reloadPage() {
		window.location.reload();
	}

	showPaginator() {
		return true;
	}
}
